import { render } from "./SelectedContent.vue?vue&type=template&id=03fe6da2&scoped=true"
import script from "./SelectedContent.vue?vue&type=script&lang=js"
export * from "./SelectedContent.vue?vue&type=script&lang=js"

import "./SelectedContent.vue?vue&type=style&index=0&id=03fe6da2&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fe6da2"]])

export default __exports__